import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { X } from "lucide-react";
import { useState } from "react";

type Genre = { id: string; name: string };

type AsideProps = {
  genres: Genre[];
  selectedGenre: string | null;
  setSelectedGenre: (genre: string | null) => void;
};
export const Aside = ({ genres, selectedGenre, setSelectedGenre }: AsideProps) => {
  const [toggleSidebar, setToggleSidebar] = useState(false);

  return (
    <aside
      className={cn(
        "fixed md:relative top-0 left-0 z-20 h-full md:h-auto w-64 shadow-lg transform transition-transform duration-300 ease-in-out md:translate-x-0 bg-card border-r border-border",
        toggleSidebar ? "translate-x-0" : "-translate-x-full"
      )}
    >
      <ul className="p-4 space-y-2">
        {genres?.map((genre) => (
          <li
            key={genre.id}
            onClick={() => setSelectedGenre(genre.id)}
            className={`cursor-pointer p-2 rounded-md text-sm transition font-medium ${
              selectedGenre === genre.id
                ? "bg-primary text-primary-foreground"
                : "text-muted-foreground hover:bg-muted"
            }`}
          >
            {genre.name}
          </li>
        ))}
      </ul>
      <Button
        variant="ghost"
        onClick={() => setToggleSidebar((prev) => !prev)}
        className="absolute z-30 top-4 right-4 text-foreground md:hidden"
      >
        <X className="h-5 w-5" />
      </Button>
    </aside>
  );
};